<template>
    <van-popup v-model="show" round :close-on-click-overlay="false" position="bottom" style="height:400px;">
      <div class="popup-title">声明</div>
      <div class="statement">
        <ol>
          <li>1.公司仅提供基于CT、MRI的3D全量化分析服务，无权提供临床医学诊断结论和治疗方案，因此不承担因为诊断结论错误或治疗方案不当而引发的医疗纠纷和事故的责任；</li>
          <li>2.用户授权公司使用处置CT或MR数据,公司对客户最终输出的是3D影像，该影像仅对对应的原始CT、MRI数据有效；</li>
          <li>3.接受本公司提供的三维重建服务的客户,将被认为完全接受以上法律声明。</li>
        </ol>
      </div>
      <div class="bts-bottom" >
        <van-row gutter="20">
            <van-col span="12" >
              <van-button round block @click="doCancel"  >取消</van-button>
            </van-col>
            <van-col span="12">
              <van-button round block type="danger" @click="doConfirm"  >确认</van-button>
            </van-col>
        </van-row>
      </div>
    </van-popup>
</template>

<script>
import { Popup, Row, Col, Button} from 'vant';
export default {
  components: {
    [Popup.name]: Popup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data() {
    return {
        show: false,
        loading: false,
        orderId: '',
        payAmount: 0,
        payAmountFmts: [],
        payStatus: -1,
        payResult: ''
    };
  },
  methods: {
    open(){
        this.show = true
    },
    doConfirm(){
      this.show = false
      this.$emit('confirm')
    },
    doCancel(){
      this.show = false
      this.$emit('cancel')
    }
  }
};
</script>
<style lang="less" scoped>
  .statement {
    margin: 20px 30px;
    li {
      padding-bottom: 10px;
    }
  }
</style>
